import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  FailedNotification,
  NotificationDropdownProps,
} from "../types/Notification.type";
import { ROUTES } from "@/shared/constants";
import { SharedNotificationDropdown } from "@/components/NotificationDropdown";

const NotificationDropdown: React.FC<NotificationDropdownProps> = ({
  isOpen,
  onClose,
  onNotificationClick,
  notifications,
}): React.ReactElement => {
  const navigate = useNavigate();

  const handleViewAll = useCallback((): void => {
    navigate(ROUTES.header.acknowledge);
    onClose();
  }, [navigate, onClose]);

  const handleNotificationClick = useCallback(
    (notification: FailedNotification): void => {
      onNotificationClick(notification);
      onClose();
    },
    [onClose, onNotificationClick],
  );

  return (
    <SharedNotificationDropdown<FailedNotification>
      isOpen={isOpen}
      onClose={onClose}
      title="System Notifications"
      emptyMessage="No system notifications"
      items={notifications}
      getItemKey={(notification): string => notification.log_id}
      onItemClick={handleNotificationClick}
      onViewAll={handleViewAll}
      renderItem={(notification): React.ReactNode => (
        <p className="min-w-0 text-sm font-medium text-foreground whitespace-normal break-words [overflow-wrap:anywhere]">
          {notification.message}
        </p>
      )}
    />
  );
};

export default NotificationDropdown;
